/* eslint-disable react/require-default-props */
import React, { ReactNode } from 'react';

import { StyledButton } from './styles';

interface ButtonInterface {
  children?: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  variant?: 'solid' | 'outline' | 'ghost';
  styles?: React.CSSProperties;
}

export default function Button({
  children,
  variant,
  ...props
}: ButtonInterface): JSX.Element {
  return (
    <StyledButton variant={variant ?? 'solid'} {...props}>
      {children}
    </StyledButton>
  );
}
